<button [@fade]="btnStatus$ | async" class="btn-scroll" (click)="resetPagePosition()">
    <ng-content></ng-content>
</button>
